import * as React from "react";
import { memo } from "react";
const SvgX = (props) => (
  <svg
    viewBox="4 4 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.75781 16.2427L16.2431 7.75739"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16.2431 16.2426L7.75781 7.75732"
      stroke="currentColor"
      strokeWidth={1.5}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
const Memo = memo(SvgX);
export default Memo;

